<template>
  <div
    class="ShoppingCart"
    v-if="ShoppingCartFlag && this.$store.state.discount > 0"
  >
    <div class="list" id="ShoppingCartList" v-if="shoppingCartList.length > 0">
      <div class="item" v-for="(item, index) in shoppingCartList" :key="index">
        <div class="left" @click="singleSelect(index, true)">
          <div :class="{ active: item.ActiveFlag }">
            <img src="../../assets/images/updataFile/select-active.png" />
            <div class="noActive"></div>
          </div>
        </div>
        <div class="right">
          <div class="r-left" @click="singleSelect(index, true)">
            <div class="name">{{ item.productName }}</div>
          </div>
          <div class="r-right">
            <div class="del" @click="removeShopping(item.id)">
              <img
                src="../../assets/images/updataFile/del.png"
                class="del-icon"
              />
            </div>
            <div
              class="price"
              style="text-decoration: line-through; color: #aaa"
              v-if="$store.state.discount < 100"
            >
              <span>￥</span>
              <span>{{ item.productPrice }}</span>
            </div>
            <div class="price">
              <span>￥</span>
              <span>{{ calculationDiscount(item.productPrice) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部全选及结算 -->
    <div
      class="shoppingCart-bottom"
      v-if="shoppingCartList.length > 0"
      :style="{ width: this.$store.state.PCFlag ? '11.04rem' : '' }"
    >
      <div class="AllElection">
        <div :class="{ active: allFlag }" @click="allFlagFun">
          <img src="../../assets/images/updataFile/select-active.png" />
          <div class="noActive"></div>
          <div class="all">全选</div>
        </div>
      </div>
      <div class="Price-box">
        <div class="allPrice">
          <span>总金额: </span>
          <span>￥{{ calculationDiscount(allPrice) }}</span>
        </div>
      </div>
      <div class="btn" @click="SettlementFun">结算</div>
    </div>
    <!-- 已选项没有数据的情况下 -->
    <div class="noShoppingCart" v-if="shoppingCartList.length == 0">
      <img src="../../assets/images/updataFile/noShoppingCart-icon.png" />
      <div class="ps">当前没有检测产品哦</div>
      <div @click="goIndex" class="btn">去添加</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ShoppingCartFlag: false,
      shoppingCartList: [],
      // 是否全选
      allFlag: true,
      allPrice: 0,
      shoppingCartFrom: {
        size: 20,
        current: 1,
        userId: "",
      },
      userInfo: {},
      scrollLoadMoreFlag: true,
    };
  },
  created() {
    if (localStorage.getItem("userInfo")) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.userInfo = userInfo;
      if (this.$isWeixin()) {
        if (
          this.$route.query.openId == "wxOpenId" &&
          !sessionStorage.getItem("wxOpenId")
        ) {
          location.href = `https://api.ibnsina360.com/wechat/authorize?returnUrl=${escape(
            location.href
          )}`;
          return;
        } else {
          if (!sessionStorage.getItem("wxOpenId"))
            sessionStorage.setItem("wxOpenId", this.$route.query.openId);
        }
      }
      this.shoppingCartFrom.userId = userInfo.id;
      this.getShoppingCart();
      sessionStorage.removeItem("selectFlag");
      window.addEventListener("scroll", this.scrollLoadMore);
      if (!this.$store.state.wxConfigFlag) this.$wxConfig();
    }
  },
  methods: {
    /**
     * 滚动到底部加载更多
     */
    scrollLoadMore() {
      let size = this.shoppingCartFrom.current * this.shoppingCartFrom.size;
      if (this.scrollLoadMoreFlag && this.total > size) {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop; // 兼容获取滚动条高度
        var scrollHeight =
          document.getElementById("ShoppingCartList").scrollHeight; // 获取整个document的高度
        var clientHeight = document.body.clientHeight; //获取当前显示的高度
        if (clientHeight + scrollTop + 30 > scrollHeight) {
          this.scrollLoadMoreFlag = false;
          this.shoppingCartFrom.current = this.shoppingCartFrom.current + 1;
          this.getShoppingCart();
        }
      }
    },
    /* 点击结算 */
    SettlementFun() {
      let list = this.shoppingCartList;
      let ids = "";
      let shoppingCarIdsTxt = "";
      let Price = 0;
      for (let i = 0; i < list.length; i++) {
        if (list[i].ActiveFlag) {
          ids += list[i].id + ",";
          shoppingCarIdsTxt = shoppingCarIdsTxt + list[i].id + ",";
          Price += list[i].productPrice;
        }
      }
      if (Price == 0) {
        this.$toots("您还没有选择产品哦");
        return;
      }
      ids = ids.substr(0, ids.length - 1);
      shoppingCarIdsTxt = shoppingCarIdsTxt.substr(
        0,
        shoppingCarIdsTxt.length - 1
      );
      let openId = this.$route.query.openId;
      this.$router.push({
        name: "FillInInfo",
        query: {
          ids: ids,
          openId: openId,
          doctorId: localStorage.getItem("doctorId"),
        },
      });
    },
    /* 根据用户id查询已选项列表 */
    getShoppingCart() {
      let data = this.shoppingCartFrom;
      this.$http
        .get(`/shoppingCart/getUserPage`, {
          params: data,
        })
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data;
            let list = data.records;
            let arr = this.shoppingCartList;
            let allPrice = this.allPrice;
            list.forEach((item) => {
              item.ActiveFlag = true;
              allPrice += item.productPrice;
              arr.push(item);
            });
            this.shoppingCartList = arr;
            this.total = data.total;
            this.allPrice = allPrice;
            this.ShoppingCartFlag = true;
            this.scrollLoadMoreFlag = true;
          }
        });
    },
    /* 选择或取消全选 */
    allFlagFun() {
      this.allFlag = !this.allFlag;
      let list = this.shoppingCartList;
      let allPrice = 0;
      list.forEach((item) => {
        item.ActiveFlag = this.allFlag;
        if (item.ActiveFlag) {
          allPrice += item.productPrice;
        }
      });
      this.allPrice = allPrice;
    },
    /* 单个的选中或取消 */
    singleSelect(index, flag, numberFlag) {
      let list = this.shoppingCartList;
      if (flag) list[index].ActiveFlag = !list[index].ActiveFlag;
      let number = 0;
      let allPrice = 0;
      list.forEach((item) => {
        if (item.ActiveFlag) {
          number++;
          allPrice += item.productPrice;
        }
      });
      if (numberFlag) number++;
      this.allPrice = allPrice;
      /* 当前选中个数等于已选项数量，选中全选，否则不选 */
      if (number == list.length) this.allFlag = true;
      else this.allFlag = false;
    },
    /* 已选项删除 */
    removeShopping(id) {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        this.$loading("删除中");
        this.$http
          .delete(`/shoppingCart/deleteById/${id}`)
          .then((res) => {
            if (res.data.code == 200) {
              let list = this.shoppingCartList;
              for (let i = 0; i < list.length; i++) {
                let item = list[i];
                if (id == item.id) {
                  if (item.ActiveFlag) this.singleSelect(i, true, true);
                  else this.singleSelect(i, false, true);
                  list.splice(i, 1);
                  i--;
                }
              }
              this.shoppingCartList = list;
              this.$tootsSuccess("删除成功");
            } else this.$toots(res.data.msg);
          })
          .catch((err) => {
            this.$toots("系统正在升级，请稍后");
          });
      }
    },
    goIndex() {
      this.$router.replace({
        name: "Index",
        query: {
          doctorId: localStorage.getItem("doctorId"),
          productTypeId: localStorage.getItem("productTypeId"),
        },
      });
    },
  },
  destroyed() {
    sessionStorage.removeItem("wxOpenId");
  },
};
</script>

<style lang='less' scoped>
.ShoppingCart {
  padding-bottom: 130px;
  background-color: #f8f8f8;
  .list {
    background-color: #f8f8f8;
    padding: 30px;
    padding-bottom: env(safe-area-inset-bottom);
    padding-bottom: constant(safe-area-inset-bottom);
    .item:last-child {
      .right {
        border-bottom: none;
      }
    }
    .item {
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      position: relative;
      min-height: 162px;
      margin-bottom: 20px;
      .left {
        height: 100%;
        width: 100px;
        > div.active {
          img {
            display: block;
          }
          .noActive {
            display: none;
          }
        }
        > div {
          width: 66px;
          .noActive {
            width: 38px;
            height: 38px;
            border-radius: 100%;
            border: 1px solid #bbbbbb;
          }
          img {
            display: none;
            width: 38px;
            height: 38px;
          }
          .noActive,
          img {
            position: absolute;
            top: 50%;
            left: 33px;
            transform: translateY(-50%);
          }
        }
      }
      .left.active {
        img {
          display: block;
        }
        > .noActive {
          display: none;
        }
      }
      .right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 30px;
        .r-left {
          flex: 1;
          .name {
            text-align: justify;
            width: 460px;
            font-size: 34px;
            font-weight: 700;
          }
        }
        .r-right {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          > .del {
            text-align: right;
            padding-top: 6px;
            img {
              width: 32px;
              height: 32px;
              margin-right: 30px;
            }
          }
          > .price {
            padding-right: 30px;
            text-align: right;
            color: #ef2538;
            font-weight: 700;
            font-size: 26px;
          }
        }
      }
    }
  }
  /* 底部全选及结算 */
  .shoppingCart-bottom {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    // height: 120px;
    box-shadow: 0 -10px 30px -5px #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding-right: 30px;
    padding-bottom: env(safe-area-inset-bottom);
    padding-bottom: constant(safe-area-inset-bottom);
    .AllElection {
      padding-left: 30px;
      width: 180px;
      > div {
        display: flex;
        justify-content: space-between;
        line-height: 120px;
        position: relative;
        > img,
        .noActive {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
        > .noActive {
          width: 38px;
          height: 38px;
          border-radius: 100%;
          border: 1px solid #bbbbbb;
        }
        > .all {
          padding-left: 58px;
          font-size: 28px;
        }
        img {
          display: none;
        }
      }
      .active {
        img {
          display: block;
          width: 38px;
          height: 38px;
        }
        > .noActive {
          display: none;
        }
      }
    }
    /* 总金额 */
    .Price-box {
      flex: 1;
      padding-right: 30px;
      text-align: right;
      line-height: 120px;
      span:nth-child(1) {
        font-size: 28px;
        color: #9a9a9a;
      }
      span:nth-child(2) {
        font-size: 40px;
        color: #ef2538;
      }
    }
    /* 结算按钮 */
    .btn {
      width: 220px;
      height: 74px;
      text-align: center;
      font-size: 34px;
      line-height: 74px;
      border-radius: 74px;
      background-color: #1968a8;
      color: #fff;
      span {
        font-size: 28px;
      }
    }
  }
  /* 已选项没有数据的时候 */
  .noShoppingCart {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 367px;
      height: 283px;
      margin: 0 auto;
      display: block;
    }
    .ps {
      font-size: 28px;
      line-height: 40px;
      color: #999999;
      text-align: center;
    }
    .btn {
      display: block;
      width: 220px;
      height: 74px;
      text-align: center;
      line-height: 74px;
      color: #fff;
      font-size: 34px;
      background-color: #1968a8;
      margin: 0 auto;
      margin-top: 60px;
      border-radius: 10px;
    }
  }
}
</style>
